/**
 *
 * ParrotSoftware
 * SettingsAdminTablesProvider root
 *
 */
import { Children, memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function AdminTables({ children }) {
  useInjectSaga({ key: 'settingsAdminTables', saga });
  useInjectReducer({ key: 'settingsAdminTables', reducer });

  return Children.only(children);
}

AdminTables.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSettingsAdminTables } from './withSettingsAdminTables';
export default compose(withConnect, memo)(AdminTables);
